import React from "react";

// Uses the official Brisk logo image supplied by the client.
// - variant="dark" → full-color logo on light backgrounds
// - variant="light" → white variant of the logo for dark backgrounds
// Width auto-scales from height to preserve the exact aspect ratio.
export default function BrandMark({ className = "h-11", variant = "dark", alt = "Brisk — One Step Ahead" }) {
  const src = variant === "light" ? "/brisk-logo-white.png" : "/brisk-logo.png";
  return (
    <img
      src={src}
      alt={alt}
      className={`${className} object-contain select-none`}
      style={{ width: "auto" }}
      draggable={false}
    />
  );
}

// Full lockup — same as BrandMark since the official logo already contains
// the triangle + BRISK + ONE STEP AHEAD wordmark.
export function LogoFull({ variant = "dark", size = "md", className = "" }) {
  const sizeMap = { sm: "h-8", md: "h-11", lg: "h-14", xl: "h-20" };
  const h = sizeMap[size] || sizeMap.md;
  return <BrandMark variant={variant} className={`${h} ${className}`} />;
}

// Compact anniversary badge — small logo + "10 Years" label styled to match reference.
export function AnniversaryBadge({ variant = "dark", className = "" }) {
  const labelColor = variant === "light" ? "text-white/60" : "text-ink-muted";
  return (
    <div className={`inline-flex items-center gap-3 ${className}`}>
      <BrandMark variant={variant} className="h-7" />
      <div className="flex items-baseline gap-0.5">
        <span className="font-display font-black text-3xl" style={{ color: "#2456C7" }}>1</span>
        <span className="font-display font-black text-3xl" style={{ color: "#E4322A" }}>0</span>
        <span className={`font-mono text-[10px] uppercase tracking-[0.2em] ml-1.5 ${labelColor}`}>Years</span>
      </div>
    </div>
  );
}
